import React from 'react'
import styled from 'styled-components'
import RouteContainer from '../../../common/styles/RouteContainer'
import { Card, Row } from 'react-bootstrap'
import RowSpacer from '../../../common/styles/RowSpacer'
import RouteTitle from '../../../common/RouteTitle/RouteTitle'
import booksitoutIcon from '../../../config/BooksitoutIcon'
import { BsFillArrowRightCircleFill as RightArrowIcon } from 'react-icons/bs'
import CardBodyContentContainer from '../../../common/styles/CardBodyContentContainer'
import RouteTitleConfig from '../../../config/RouteTitleConfig'
import useHtmlTitle from '../../../common/useHtmlTitle'

const SettingsRoute = () => {
	useHtmlTitle('설정')

	return (
		<RouteContainer>
			<RouteTitle icon={<booksitoutIcon.settings />} title={'설정'} currentKey={'main'} buttons={RouteTitleConfig.Settings} />

			<RowSpacer />
			<Row>
                <Col>
					<SettingsCard title={'계정 설정'} contents={['로그인한 기기 관리', '카카오, 네이버, 구글 계정 추가', 'Passkey 추가']} link={`/settings/personal-infos`} />
				</Col>

				<Col>
					<SettingsCard title={'내 프로필 설정'} contents={['프로필 사진 변경', '닉네임 변경']} link={`/settings/profiles`} />
				</Col>

				<Col>
					<SettingsCard title={'내 서재 설정'} contents={['책 구할 곳 설정']} link={`/settings/book-shelf`} />
				</Col>

				<Col>
					<SettingsCard title={'검색 설정'} contents={['도서관 검색 방법 지정', '도서관 검색할 지역 설정', '검색한 도서관 지정']} link={`/settings/search`} />
				</Col>

				<Col>
					<SettingsCard title={'회원탈퇴'} contents={[]} link={`/settings/withdraw`} danger />
				</Col>
			</Row>

			<RowSpacer />
		</RouteContainer>
	)
}

interface Props {
	title: string
	contents: string[]
	link: string
	danger?: boolean
}

const SettingsCard: React.FC<Props> = ({ title, contents, link, danger }) => {
	return (
		<Card className="mb-4">
			<CardBodyContentContainer style={{ minHeight: '300px' }}>
				<a href={link}>
					<div className="row row-eq-height">
						<div className="col-10">
							<h3 className="mb-4" style={{ color: danger ? 'var(--danger)' : 'var(--text-color)' }}>
								{title}
							</h3>
							<div className="ms-4 text-secondary">
								{contents.map(content => (
									<p className="mb-2" style={{ color: 'var(--sub-text-color)' }}>
										{content}
									</p>
								))}
							</div>
						</div>

						<div className="col-2" style={{ minHeight: '260px' }}>
							<div className="d-flex justify-content-end align-items-center h-100">
								<RightArrowIcon style={{ color: danger ? 'var(--danger)' : undefined }} className={danger ? '' : 'text-book'} size={30} />
							</div>
						</div>
					</div>
				</a>
			</CardBodyContentContainer>
		</Card>
	)
}

const Col = styled.div.attrs({
	className: 'col-12 col-md-6 hover-effect',
})``

export default SettingsRoute
